"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../util/ServiceUrlUtility"));

var _ServiceSettings = _interopRequireDefault(require("../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SERVICE_PATH = '/retail/irms/{apiLocalePath}/stores';
/**
 * This class is used for fetching and parsing store data for IRW.
 */

var IrwStoreService = /*#__PURE__*/function (_AbstractService) {
  _inherits(IrwStoreService, _AbstractService);

  var _super = _createSuper(IrwStoreService);

  /**
   * Class constructor.
   */
  function IrwStoreService() {
    var _this;

    _classCallCheck(this, IrwStoreService);

    _this = _super.call(this);
    _this.serviceVersion = '2';
    return _this;
  }
  /**
   * Fetches and returns stores.
   *
   * @param {String} apiLocalePath API locale path. Example: "gb/en".
   * @return {Promise} Promise object.
   */


  _createClass(IrwStoreService, [{
    key: "getStores",
    value: function getStores(apiLocalePath) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this2._getUrl(apiLocalePath), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: _this2._getAcceptHeader(),
            Contract: _ServiceSettings.default.contract.toString(),
            Consumer: _ServiceSettings.default.consumer
          }
        }).then(_this2._handleJsonResponse.bind(_this2)).then(function (data) {
          return resolve(_this2._parse(data));
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Parses store data.
     *
     * @param {Object} data Store data.
     * @return {Object} Parsed data.
     */

  }, {
    key: "_parse",
    value: function _parse(data) {
      var stores = [];

      if (data.StoreRefList && data.StoreRefList.StoreRef) {
        var storeItems = Array.isArray(data.StoreRefList.StoreRef) ? data.StoreRefList.StoreRef : [data.StoreRefList.StoreRef];

        var _iterator = _createForOfIteratorHelper(storeItems),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var storeItem = _step.value;
            stores.push({
              location: storeItem.StoreLocation && storeItem.StoreLocation.Latitude && storeItem.StoreLocation.Latitude.$ ? {
                latitude: storeItem.StoreLocation.Latitude.$,
                longitude: storeItem.StoreLocation.Longitude.$
              } : null,
              name: storeItem.StoreName && storeItem.StoreName.$ ? storeItem.StoreName.$ : null,
              id: storeItem.StoreNo && storeItem.StoreNo.$ ? String(storeItem.StoreNo.$) : null,
              url: storeItem.StoreUrl && storeItem.StoreUrl.$ ? storeItem.StoreUrl.$ : null
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return stores;
    }
    /**
     * Returns the accept header.
     *
     * @return {String} Accept header.
     */

  }, {
    key: "_getAcceptHeader",
    value: function _getAcceptHeader() {
      return 'application/vnd.ikea.irms+json; version=' + this.serviceVersion;
    }
    /**
     * Returns the URL to use for the service.
     *
     * @param {String} apiLocalePath API locale path. Example: "gb/en".
     * @return {Number} Calculated height.
     */

  }, {
    key: "_getUrl",
    value: function _getUrl(apiLocalePath) {
      return _ServiceUrlUtility.default.getBaseUrl() + this._getServicePath().replace('{apiLocalePath}', apiLocalePath);
    }
    /**
     * Returns the service path to be used for the URL.
     *
     * @return {String} Service path.
     */

  }, {
    key: "_getServicePath",
    value: function _getServicePath() {
      return SERVICE_PATH;
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'irwstore';
    }
  }]);

  return IrwStoreService;
}(_AbstractService2.default);

exports.default = IrwStoreService;